export const CARS_LOADING = "CARS_LOADING";
export const GET_BODY_TYPES = "GET_BODY_TYPES";
export const GET_BRANDS = "GET_BRANDS";
export const GET_BIKE_TYPE = "GET_BIKE_TYPE";
export const GET_MODEL_BY_MAKE = "GET_MODEL_BY_MAKE";
export const REMOVE_CAR_DATA = "REMOVE_CAR_DATA";
